import useOnboardingPortalStore from "../OnboardingPortal.Store";
import Modal from "../../../components/modal/Modal";
import { useTranslation } from "@me8eon/translation";
import { EonUiButton } from "@eon-ui/eon-ui-components-react";

const ViewQnAModal = () => {
    const t = useTranslation();
    const { showViewQnA, viewQnAData, resetViewQnA } =
        useOnboardingPortalStore();

    return (
        <>
            <Modal
                toggleModal={showViewQnA}
                closeModal={resetViewQnA}
                isCloseIcon={false}
                closeOnBackdrop={true}
                modalClass="review-modal"
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                        padding: 20,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 12,
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.category`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {viewQnAData?.category}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.question`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {viewQnAData?.question}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.answer`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {viewQnAData?.answer}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(
                                    `onboardingPortal.modalLabel.companiesAllowed`
                                )}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {viewQnAData?.companiesAllowed.join(", ")}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(
                                    `onboardingPortal.modalLabel.companiesRestricted`
                                )}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {viewQnAData?.companiesRestricted.join(", ")}
                            </span>
                        </div>
                    </div>
                    {viewQnAData?.status !== "pending" &&
                        viewQnAData?.reviewerNote && (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 4,
                                }}
                            >
                                <span
                                    style={{
                                        color: "#666666",
                                        fontSize: "14px",
                                    }}
                                >
                                    {t(
                                        `onboardingPortal.modalLabel.reviewerComments`
                                    )}
                                </span>
                                <span
                                    style={{
                                        color: "#1E1E1E",
                                        fontSize: "20px",
                                        fontWeight: "medium",
                                    }}
                                >
                                    {viewQnAData?.reviewerNote}
                                </span>
                            </div>
                        )}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 8,
                            alignItems: "center",
                            justifyContent: "flex-end",
                        }}
                    >
                        <EonUiButton
                            rank="primary"
                            onClick={() => resetViewQnA()}
                            size="small"
                            text={t("onboardingPortal.closeBtn")}
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ViewQnAModal;
